<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon">
</app-page-title>
<div class="card" *ngIf="!loading">
    <div class="card-body row">        
        <transfers-block [transfers]="audience.transfers" [audience]="audience" style="width: 100%;"></transfers-block>
    </div>
</div>
